const Url = {
    apiUrl: "http://api.ykshenzhen.com/api/",
    //apiUrl: "http://test-shenzhen.api.yingkelawyer.com/api/",
    //apiUrl:"http://172.16.22.67:2261/api/",
    // apiUrl: "http://localhost:8094/api/",
    // apiUrl:"http://localhost:8094/api/",
        imgUrl: ""
}



export default Url;